// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".componentWrapper{display:-ms-flexbox;display:flex;-ms-flex:1;flex:1}", ""]);
// Exports
module.exports = exports;
